import { environment } from '~env/environment';

export const API_BEST_SELLING_PRODUCTS_LIST = () => `${environment.svcSearch2BaseUrl()}/api/v3/popular-products`;
export const API_LAST_DEALS_PRODUCTS_LIST = () => `${environment.svcSearch2BaseUrl()}/api/v3/search`;
export const BEST_SELLING_PRODUCTS_LIMIT = 10;
export const BEST_SELLING_PRODUCTS_OFFSET = 0;
export const API_CUSTOM_HUBPAGE_ROUTE = () =>
  `${environment.getSvcStorefrontBaseUrl()}/api/v1/public/cms/custom-hub-pages/view`;
